import { render, staticRenderFns } from "./ImgUploader.vue?vue&type=template&id=25b160fc&scoped=true&"
import script from "./ImgUploader.vue?vue&type=script&lang=js&"
export * from "./ImgUploader.vue?vue&type=script&lang=js&"
import style0 from "./ImgUploader.vue?vue&type=style&index=0&id=25b160fc&lang=scss&scoped=true&"
import style1 from "./ImgUploader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b160fc",
  null
  
)

export default component.exports